import { Box, Button, Divider, Modal, Stack } from '@mui/material'
import React from 'react'
import ImageCrop from '../../../../common/components/ImageCrop'
import styled from '@emotion/styled'
import { COLOR_MAP } from '../../../../constants/ColorNames'
import ImageUpload from '../../../../common/components/ImageUpload'
import AlertIcon from '../../../../constants/icons/AlertIcon'



type CompanyMediaModalPropsType = {
  handleMediaUpload: (files: FileList) => void;
  handleClose: (isEdited: boolean) => void;
  mediaFile: FileList | string | null;
  uploadedMedia: string;
  handleUpdateMedia: (src: string) => void;
  type: 'logo' | 'cover';
  errorMessage: string
}



const ErrorMessage = styled.p`
  font-weight:400 ;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin: 0;
  margin-top: 0.6rem;
  width: 95%;
  color: ${COLOR_MAP.FAILURE}
`

const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 68.2rem;
  border-radius: 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${COLOR_MAP.WHITE};
  &:focus {
    outline: none;
    box-shadow: none;
  }
`

const Header = styled.p`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.4rem;
  text-align: left;
  padding: 1.6rem;
  width: 95%;
`;

const UploadInfoText = styled.p`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin-bottom: 0.6rem;
  width: 100%;
  text-align: left;
  padding-left: 3.2rem;
`

export const CompanyMediaModal = (props: CompanyMediaModalPropsType) => {
  const [croppedImg, setCroppedImg] = React.useState('');

  const { handleMediaUpload, handleClose, mediaFile, handleUpdateMedia, type, uploadedMedia, errorMessage } = props;

  const cropHeight = type === 'logo' ? 160 : 150;
  const cropWidth = type === 'logo' ? 160 : 648;

  const headerText = type === 'logo' ? 'Company logo' : 'Company cover image';
  const uploadInfoText = type === 'logo' ? 'Upload company logo (Upload JPEG or PNG,  Size 160 X 160px, Max 1MB)' : 'Upload company cover image (Upload JPEG or PNG,  Size 648 X 150px, Max 1MB)';

  const placeholderText = type === 'logo' ? 'Upload company logo here' : 'Upload company cover image here';

  const handleSubmit = (src: string) => {
   setCroppedImg(src);
  };

  const handleOnDone = React.useCallback(() => {
    handleUpdateMedia(croppedImg);
    handleClose(true);
  }, [croppedImg, handleClose, handleUpdateMedia]);


  return (
    <Modal
      open={true}
      onClose={() =>handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalBox>
        <Header>{headerText}</Header>
        <Divider
          style={{
            height: '0.1rem',
            marginBottom: '2.4rem',
            backgroundColor: COLOR_MAP.DISABLED
          }}
          orientation="vertical"
          flexItem
        />
        <UploadInfoText>{uploadInfoText}</UploadInfoText>
        {mediaFile ? <ImageCrop height={cropHeight} width={cropWidth} onSubmit={handleSubmit} media={mediaFile || uploadedMedia} />
          : <ImageUpload id={'logo'} type='Placeholder' placeholderText={placeholderText} onChange={handleMediaUpload} />
        }
        {
          errorMessage &&
              <Box sx={{
                display: 'flex',
                gap: '6px',
                width: '95%',
                alignItems: 'flex-end',
                justifyContent: 'flex-start'
              }}>
                <AlertIcon/>
            <ErrorMessage>{errorMessage}</ErrorMessage>
            </Box>
        }
        <Divider
          style={{
            height: '0.1rem',
            marginTop: errorMessage ? '.6rem' : '1.2rem',
            backgroundColor: COLOR_MAP.DISABLED
          }}
          orientation="vertical"
          flexItem
        />
        <Stack
          justifyContent='end'
          direction='row'
          sx={{
            padding: '1.6rem',
          }}
          spacing={1}
          width='95%' >
          <Button sx={{
            padding: '0.8rem 1.2rem'
          }} variant='text' disableRipple onClick={() => handleClose(false)}>Cancel</Button>
          <ImageUpload variant='outlined' id={'logo'} label={mediaFile ? 'Use Another Image' : 'Browse'} onChange={handleMediaUpload} />
          {mediaFile && <Button onClick={handleOnDone} disabled={Boolean(errorMessage)} variant='contained'>Done</Button>}
        </Stack>
      </ModalBox>
    </Modal>
  )
}
